/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Icon } from 'semantic-ui-react';

import BoothForm from '../forms/booth-form';
import EditItemDialog from '../dialogs/edit-item-dialog';
import { CardAttr } from '../widgets/card-attr';
import TicketList, { TicketItem } from '../ticket-list';
import { DeviceStatus } from '../device-status';
import { getBoothLink, getBoothSettingsLink } from '../../utils/device-utils';

import styled from 'styled-components';
import { colors } from '../../themes';

import formatLastSeenOnline from '../../utils/format-last-seen-online';
import { UnsupportedDeleteIcon } from './unsupported-delete-icon';

const Container = styled.div`
  padding: 1em;
  span.led,
  i.browser {
    margin-right: 0.5em;
  }
`;
const Header = styled.section`
  display: grid;
  grid-template-columns: 1fr auto;
`;
const Actions = styled.div`
  i {
    cursor: pointer;
  }
  i.remove {
    color: ${colors.baseColors.red};
    margin-right: 0px;
  }
`;
const Content = styled.section`
  display: grid;
  grid-gap: 4px;
  time {
    margin-right: 1em;
  }
`;

function Title(props: any) {
  return (
    <span>
      <Icon name="browser" />
      <DeviceStatus connectionStatus={props.connectionStatus} title={props.name} />
    </span>
  );
}
export default function BoothCard(props: any) {
  return (
    <Container>
      <Header className="card-header">
        <h3>
          <Title {...props} />
        </h3>
        <Actions>
          <EditItemDialog form={BoothForm} {...props} />
          <UnsupportedDeleteIcon what="booth" />
        </Actions>
      </Header>
      <Content>
        <CardAttr title="Last seen online">{formatLastSeenOnline(props.lastSeenOnline)}</CardAttr>
        <CardAttr title="Link">
          <a href={getBoothLink(props.uuid)} target="_blank">
            Booth app
          </a>
        </CardAttr>
        <CardAttr title="Link">
          <a href={getBoothSettingsLink(props.uuid)} target="_blank">
            Booth app (Settings)
          </a>
        </CardAttr>
        <CardAttr title="Queues">
          {props.queues.map((q: any) => (
            <span key={q._id}>{`${q.sequenceId} ${q.name}`}, </span>
          ))}
        </CardAttr>
        <CardAttr title="code">{props.code}</CardAttr>
        <CardAttr title="uuid">{props.uuid}</CardAttr>
        <CardAttr title="secret">{props.secret}</CardAttr>
        <CardAttr title="currentTicket">
          <TicketItem {...props.currentTicket} />
        </CardAttr>
        <CardAttr title="previousTickets">
          <TicketList items={props.previousTickets} />
        </CardAttr>
        <CardAttr title="CBX">{props.controlBox.uuid}</CardAttr>
      </Content>
    </Container>
  );
}
